<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 16 16"
  fill="none"
>
  <circle cx="8" cy="8" r="8" [attr.fill]="color"/>
  <path d="M10 4L6 8L10 12" stroke="white" stroke-width="1.5"/>
</svg>
